import apiClient from './apiClient';

export const getTradeSignalAnalysis = async (filters = {}) => {
  const params = new URLSearchParams();
  
  // Add filters to query parameters
  if (filters.symbol) {
    params.append('symbol', filters.symbol);
  }
  if (filters.fromDate) {
    params.append('fromDate', filters.fromDate);
  }
  if (filters.toDate) {
    params.append('toDate', filters.toDate);
  }
  if (filters.active !== undefined) {
    params.append('active', filters.active);
  }
  if (filters.hit3R) {
    params.append('hit3R', 'true');
  }
  if (filters.stoppedOut) {
    params.append('stoppedOut', 'true');
  }
  if (filters.limit) {
    params.append('limit', filters.limit);
  }
  if (filters.offset) {
    params.append('offset', filters.offset);
  }
  if (filters.sortBy) {
    params.append('sortBy', filters.sortBy);
  }
  if (filters.sortOrder) {
    params.append('sortOrder', filters.sortOrder);
  }
  if (filters.strategy) {
    params.append('strategy', filters.strategy);
  }

  const response = await apiClient.get(`/trade-signals/analysis?${params.toString()}`);
  return response.data;
}; 